// Auth actions
export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const LOGOUT = "LOGOUT";
export const TOGGLE = "TOGGLE";

//Other actions
export const COMPANY_SWITCH= 'COMPANY_SWITCH';

